import React,{useState} from "react";
import PropTypes from "prop-types";
// import Cookies from "universal-cookie";
import { useTranslation } from "react-i18next";

// import { useTheme } from "@mui/material/styles"; // code clean up
import makeStyles from "@mui/styles/makeStyles";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import InfoIcon from "@mui/icons-material/Info";
import EditIcon from "@mui/icons-material/Edit";
import PublishIcon from "@mui/icons-material/Publish";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ChromeReaderModeIcon from "@mui/icons-material/ChromeReaderMode";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

const useStyles = makeStyles((theme) => ({
  xsFont: {
    [theme.breakpoints.down("sm")]: { fontSize: 14 },
    textAlign: "center",
  },
  rowHeight: {
    [theme.breakpoints.up("xl")]: { height: 56 },
    [theme.breakpoints.down("xl")]: { height: 90 },
  },
  actionButton: {
    backgroundColor: "#9dba79",
    "&:hover": {
      backgroundColor: "#84a957",
    },
    borderRadius: 5,
    boxShadow:
      "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
    color: "#fff",
    fontWeight: 600,
    width: 105,
  },
}));

const ToDoRows = ({
  items,
  reviewClick,
  uploadClick,
  exampleClick,
  signatureClick,
  user,
}) => {
  const classes = useStyles();
  // const cookies = new Cookies();
  const { t, i18n } = useTranslation();
  // const user = cookies.get("lifesaferUser");
   const [openTooltipId, setOpenTooltipId] = useState(null);
  return (
    <>
      {items.map((documentObj, id) => {
        return (
          <div key={id}>
            <Grid
              container
              direction="row"
              alignItems="center"
              style={{
                background: id % 2 ? "#fafafa" : "white",
              }}
            >
              <Grid item xs={4} sm={3} className={classes.xsFont} md={4}>
                <Typography
                  className={classes.xsFont}
                  style={{ paddingLeft: 5 }}
                  noWrap
                >
                  {documentObj.name}
                </Typography>
              </Grid>
              <Grid item xs={4} sm={2} className={classes.xsFont} md={4}>
                <Tooltip
                open={openTooltipId === id}
                disableTouchListener
                onOpen={() => setOpenTooltipId(id)}
                onClose={() => setOpenTooltipId(null)}
                  title={
                    <h3>
                      {documentObj.name}
                      {documentObj.make === "" ? null : (
                        <>
                          <br />
                          {documentObj.make +
                            " " +
                            documentObj.model +
                            " " +
                            documentObj.vehYear}
                        </>
                      )}
                      {documentObj.beginDT === undefined ||
                      documentObj.beginDT === null ? null : (
                        <>
                          <br />
                          {t("documents.appointment") +
                            ": " +
                            documentObj.beginDT}
                        </>
                      )}
                    </h3>
                  }
                >
                  <IconButton onClick={() => setOpenTooltipId(openTooltipId === id ? null : id)} size="large">
                    <InfoIcon style={{ color: "#00798c" }} />
                  </IconButton>
                </Tooltip>
              </Grid>
              {(() => {
                switch (documentObj.type.toUpperCase()) {
                  case "TEMPLATE": // && ELECTRONICSIGNATUREAGREEMENT ??
                    return (
                      <Grid
                        container
                        item
                        direction={"row"}
                        justifyContent={"center"}
                        xs={4}
                        sm={3}
                        className={classes.xsFont}
                        md={4}
                      >
                        <Grid item className={classes.xsFont} md={4}>
                          <Button
                            className={classes.actionButton}
                            size="small"
                            variant="contained"
                            startIcon={<EditIcon />}
                            onClick={(e) => {
                              signatureClick(e, documentObj);
                            }}
                            disabled={documentObj.disabled}
                            style={
                              i18n.language === "es" ? { fontSize: 11 } : {}
                            }
                          >
                            {t("documents.template")}
                          </Button>
                        </Grid>
                      </Grid>
                    );
                  case "SIGNATUREREPORTS":
                    return (
                      <>
                        <Grid
                          container
                          item
                          direction={"row"}
                          justifyContent={"center"}
                          xs={4}
                          sm={3}
                          className={classes.xsFont}
                          md={4}
                        >
                          <Grid item className={classes.xsFont} md={4}>
                            <Button
                              className={classes.actionButton}
                              size="small"
                              variant="contained"
                              startIcon={<EditIcon />}
                              onClick={(e) =>
                                reviewClick(
                                  e,
                                  user.clientID,
                                  documentObj.appointmentID,
                                  documentObj.jurisdictionID,
                                  documentObj.locationID,
                                  documentObj.id,
                                  documentObj.type,
                                  documentObj.name,
                                  user.languageID,
                                  documentObj.vehicleID
                                )
                              }
                              disabled={documentObj.disabled}
                              style={
                                i18n.language === "es" ? { fontSize: 11 } : {}
                              }
                            >
                              {t("documents.review")}
                            </Button>
                          </Grid>
                        </Grid>
                      </>
                    );
                  case "NONSIGNATUREREPORTS":
                    return (
                      <>
                        <Grid
                          container
                          item
                          direction={"row"}
                          justifyContent={"center"}
                          xs={4}
                          sm={3}
                          className={classes.xsFont}
                        >
                          <Grid item className={classes.xsFont} md={4}>
                            <Button
                              className={classes.actionButton}
                              size="small"
                              variant="contained"
                              startIcon={<ChromeReaderModeIcon />}
                              onClick={(e) =>
                                reviewClick(
                                  e,
                                  user.clientID,
                                  documentObj.appointmentID,
                                  documentObj.jurisdictionID,
                                  documentObj.locationID,
                                  documentObj.id,
                                  documentObj.type,
                                  documentObj.name,
                                  user.languageID,
                                  documentObj.vehicleID
                                )
                              }
                              disabled={documentObj.disabled}
                              style={
                                i18n.language === "es" ? { fontSize: 11 } : {}
                              }
                            >
                              {t("documents.review")}
                            </Button>
                          </Grid>
                        </Grid>
                      </>
                    );
                  case "UPLOADS":
                    return (
                      <Grid
                        container
                        item
                        direction={"row"}
                        justifyContent={"center"}
                        spacing={1}
                        xs={4}
                        sm={3}
                        style={{ paddingTop: 5, paddingBottom: 5 }}
                        md={4}
                      >
                        <Grid item className={classes.xsFont}>
                          <Button
                            className={classes.actionButton}
                            size="small"
                            variant="contained"
                            startIcon={<PublishIcon />}
                            onClick={() => {
                              uploadClick(documentObj.id, documentObj.name);
                            }}
                            style={
                              i18n.language === "es" ? { fontSize: 11 } : {}
                            }
                          >
                            {t("documents.upload")}
                          </Button>
                        </Grid>
                        <Grid item className={classes.xsFont}>
                          <Button
                            className={classes.actionButton}
                            size="small"
                            variant="contained"
                            startIcon={<AssignmentIcon />}
                            onClick={() => {
                              exampleClick(documentObj.id, documentObj.name);
                            }}
                            style={
                              i18n.language === "es" ? { fontSize: 11 } : {}
                            }
                          >
                            {t("documents.documentExample")}
                          </Button>
                        </Grid>
                      </Grid>
                    );
                  default:
                    return (
                      <Grid
                        container
                        item
                        direction={"row"}
                        justifyContent={"center"}
                      >
                        <Grid item sm={4} className={classes.xsFont} md={4}>
                          <Button
                            className={classes.actionButton}
                            size="small"
                            variant="contained"
                            startIcon={<EditIcon />}
                            onClick={() => reviewClick(id)}
                            style={
                              i18n.language === "es" ? { fontSize: 11 } : {}
                            }
                          >
                            {documentObj.type}
                          </Button>
                        </Grid>
                      </Grid>
                    );
                }
              })()}
            </Grid>
          </div>
        );
      })}
    </>
  );
};

ToDoRows.propTypes = {
  items: PropTypes.array,
  reviewClick: PropTypes.func,
  uploadClick: PropTypes.func,
  exampleClick: PropTypes.func,
  signatureClick: PropTypes.func,
  user:PropTypes.object,
};

export default ToDoRows;
